import styled from '@emotion/styled'
import { Product } from '@news-mono/web-common'
import {
    breakpoint,
    breakpointBetween,
    calcRem,
    metrics,
    themedValue,
} from '../..'
import { StyledBauhausVideoCard } from '../../cards/BauhausVideoCard/BauhausVideoCard.styled'

interface StyledCarouselWrapperProps {
    isSevenNewsV2?: boolean
}
export const StyledCarouselWrapper = styled('div')<StyledCarouselWrapperProps>(
    ({ theme, isSevenNewsV2 }) => ({
        display: 'none',
        [breakpoint(`${theme.kind === Product.SevenNews ? 'sm' : 'md'}`)]: {
            display: 'block',
        },
        position: 'absolute',
        right: 0,
        width: isSevenNewsV2 ? '30%' : '40%',
        height: '100%',
        [breakpointBetween('sm', 'md')]: {
            width: isSevenNewsV2 ? '20%' : undefined,
        },
        '& [class*="StyledSkeleton"]': {
            backgroundColor: isSevenNewsV2 ? '#000' : undefined,
            backgroundImage: isSevenNewsV2
                ? 'linear-gradient(90deg, #000, #333, #000)'
                : undefined,
        },
    }),
)

export const StyledCarousel = styled('div')(({ theme }) => ({
    display: 'none',
    height: themedValue(theme, {
        sevennews: '100%',
        fallback: undefined,
    }),
    [breakpoint(`${theme.kind === Product.SevenNews ? 'sm' : 'md'}`)]:
        theme.kind === Product.PerthNow
            ? undefined
            : {
                  position: 'relative',
                  flex: 1,
                  display: 'flex',
                  overflowY: 'scroll',
                  flexDirection: 'column',
                  padding: calcRem(3, 10, 0, 10),
                  marginLeft: calcRem(15),
                  scrollBehavior: 'smooth',
              },
    '&::-webkit-scrollbar': {
        width: theme.kind === 'thewest' ? '8px' : undefined,
    },
    '&::-webkit-scrollbar-track': {
        background: theme.colors.components?.videoHub?.scrollBar?.track,
    },

    '&::-webkit-scrollbar-thumb': {
        background: theme.colors.components?.videoHub?.scrollBar?.thumb,
    },
}))

export const StyledCarouselWrapperWeb = styled('div')(({ theme }) => ({}))

interface StyledCarouselWrapperMobileProps {
    isSevenNewsV2?: boolean
}

export const StyledCarouselWrapperMobile = styled(
    'div',
)<StyledCarouselWrapperMobileProps>(({ theme, isSevenNewsV2 }) => ({
    position: 'relative',
    gridRowStart: 'span 2',
    marginTop: themedValue(theme, {
        sevennews: isSevenNewsV2 ? 0 : calcRem(40),
        fallback: calcRem(15),
    }),
    marginBottom: theme.kind === 'thewest' ? calcRem(8) : undefined,
    width:
        theme.kind === Product.PerthNow
            ? undefined
            : `calc(100vw - ${2 * metrics.sevennews.margins.md}px)`,
    paddingLeft: theme.kind === Product.PerthNow ? calcRem(8) : undefined,
    padding: isSevenNewsV2 ? calcRem(0, 16) : undefined,

    [breakpoint('sm')]: {
        width:
            theme.kind === Product.PerthNow
                ? undefined
                : `calc(100vw - ${2 * metrics.sevennews.margins.lg}px)`,
        display: theme.kind === Product.SevenNews ? 'none' : undefined,
    },
    [breakpoint('md')]: {
        display:
            theme.kind === Product.PerthNow || theme.kind === Product.SevenNews
                ? undefined
                : 'none',
    },
    [`${StyledBauhausVideoCard}`]: {
        maxWidth: theme.kind === 'thewest' ? calcRem(264) : calcRem(304),
    },
    '& .swiper': {
        paddingLeft: calcRem(3),
        marginRight: calcRem(-14),
        marginLeft: calcRem(-2),
        paddingBottom:
            theme.kind === Product.SevenNews ? calcRem(5) : undefined,
        height: theme.kind === Product.PerthNow ? '116px' : undefined,
    },
    '& .swiper-slide': {
        width: isSevenNewsV2 ? calcRem(140) : 'auto',
        marginTop: calcRem(3),
    },
}))
